// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eD9K9{display:flex;flex-direction:column;gap:12px}.tB5wc{display:flex;align-items:center;gap:8px}.l3xWc{display:grid;grid-template-columns:1fr 1fr;gap:8px}.l3xWc.F1Ccj{grid-template-columns:1fr;gap:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `eD9K9`,
	"checkboxRow": `tB5wc`,
	"fieldsRow": `l3xWc`,
	"mobile": `F1Ccj`
};
export default ___CSS_LOADER_EXPORT___;
